import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getActiveInstallsData } from '@atlassian/mpac-api-client';
import { BaseHandler } from '../../graphql-orchestrator-link';
import { transposeActiveInstallsData } from './ActiveInstallsTransposeUtils';
export class ActiveInstallsHandler extends BaseHandler {
  constructor(mpacBaseUrl) {
    super();
    _defineProperty(this, "mpacBaseUrl", void 0);
    this.mpacBaseUrl = mpacBaseUrl;
  }
  responseTransformer(operation, _transformedOperation, _sequenceConfigValue, _primaryResponse, customResponse) {
    var _customResponse$recor;
    const {
      groupBy
    } = operation.variables;
    if (customResponse !== null && customResponse !== void 0 && (_customResponse$recor = customResponse.records) !== null && _customResponse$recor !== void 0 && _customResponse$recor.length) {
      return {
        marketplaceConsoleAppActiveInstalls: transposeActiveInstallsData(customResponse, groupBy)
      };
    }
    return {
      marketplaceConsoleAppActiveInstalls: []
    };
  }

  // TODO: remove this when mock data is no longer needed
  // eslint-disable-next-line max-lines-per-function
  async fetchCustom(operation, _transformedOperation, _sequenceConfigValue, _primaryResponse) {
    const {
      appKey,
      startDate,
      endDate,
      groupBy,
      partnerId
    } = operation.variables;
    const activeInstallsData = await getActiveInstallsData(this.mpacBaseUrl, {
      appKey,
      startDate,
      endDate,
      groupBy,
      partnerId
    });
    return activeInstallsData;
  }
}